const makeSecureImageUrl = (url, transform, seoImageName) => {
  let replacedUrl = ""
  let newTransform = transform
  newTransform = newTransform.replace(/^\//, "").replace(/\/$/, "")
  if (newTransform) {
    newTransform = `${newTransform}/`
  }

  // check for Shopify Accentuate Image
  if (url.match(/cdn\.accentuate/)) {
    replacedUrl = url.replace(
      /(https?:)?\/\/cdn\.accentuate\.io\/(\d+)\/(\d+)\/(.+)/g,
      `https://mindbodygreen-res.cloudinary.com/image/upload/${newTransform}act/$2/$3/$4`,
    )
  } else if (url.match(/\.cloudinary\.com/)) {
    // image already has a Cloudinary URL but we can update it
    replacedUrl = url.replace(
      /https?:\/\/(mindbodygreen-)?res\.cloudinary\.com\/(images|image\/upload)\/(v[0-9]+\/)?/,
      `https://mindbodygreen-res.cloudinary.com/$2/${newTransform}`,
    )
  } else if (seoImageName) {
    replacedUrl = url.replace(
      /((http(s)?:)?\/\/(s3\.amazonaws\.com\/mbg|(www|res)\.mindbodygreen\.com)\/)?img\//g,
      `https://mindbodygreen-res.cloudinary.com/images/${newTransform}`,
    )
    const re = /(?:\.([^.]+))?$/
    const ext = re.exec(replacedUrl)[0]
    replacedUrl = replacedUrl.replace(new RegExp(`${ext}$`), `/${seoImageName}${ext}`)
  } else {
    replacedUrl = url.replace(
      /((http(s)?:)?\/\/(s3\.amazonaws\.com\/mbg|(www|res)\.mindbodygreen\.com)\/)?img\//g,
      `https://mindbodygreen-res.cloudinary.com/image/upload/${newTransform}`,
    )
  }
  return replacedUrl
}

module.exports = makeSecureImageUrl
